module.exports = __webpack_public_path__ + "img/logpj.ea532a91.png";